import { Auth } from 'aws-amplify'
import { removeItem } from '../middleware/storage'

export default {
  methods: {
    async logout() {
      if (this.$store.getters.hasUnsavedChanges) {
        const answer = window.confirm(this.$t('global.unsavedChanges'))
        if (!answer) {
          return
        }
      }

      try {
        await Auth.signOut()
        await this.$store.dispatch('user/logout')
        await this.$apollo.getClient().clearStore()
        removeItem('redirect')
        await this.$router.push({ name: 'LoginPage' })
      } catch (error) {
        console.error('error signing out: ', error)
      }
    },
  },
}
